import IBuildingOverlay = ZoningAPI.IBuildingOverlay;
import { getPrettyOverlayType } from '../enums/building-overlay-type';
import { ClonableItem } from './clonable-item';
import { AttributeModel } from './attribute.model';

export class BuildingOverlay extends ClonableItem<IBuildingOverlay> implements IBuildingOverlay {
    Id: number;
    Name: string;
    Description: string;
    CalibrationType: number;
    Attributes: AttributeModel[];

    constructor(value?: IBuildingOverlay) {
        super(value);
        this.Attributes = this.Attributes || []; // Set default value
        this.initAttributes();
    }

    get hasAssumptions(): boolean {
        return this.Attributes.some(attribute => attribute.isAssumption);
    }

    get hasLinks(): boolean {
        return this.Attributes.some(attribute => attribute.isLink);
    }

    get hasComments(): boolean {
        return this.Attributes.some(attribute => attribute.isComment);
    }

    get isCalibrationSet(): boolean {
        return true;
    }

    get hasDescription(): boolean {
        return !!this.Description;
    }

    get calibrationTypeStr() {
        return getPrettyOverlayType(this.CalibrationType);
    }

    private initAttributes() {
        this.initInstancesCollection('Attributes', AttributeModel);
    }
}
